import { render, staticRenderFns } from "./ExtraEquipmentGroup.vue?vue&type=template&id=570d0847&scoped=true&"
import script from "./ExtraEquipmentGroup.vue?vue&type=script&lang=js&"
export * from "./ExtraEquipmentGroup.vue?vue&type=script&lang=js&"
import style0 from "./ExtraEquipmentGroup.vue?vue&type=style&index=0&id=570d0847&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570d0847",
  null
  
)

export default component.exports